import ContainerPainel from 'components/container_painel';
import { HorizontalStepper } from 'components/shared/horizontal_stepper';
import React from 'react';
import { ROUTES } from 'routes/constants';
import useConfirmSchoolFeeding from './useConfirmSchoolFeeding';
import { PageTitle } from 'components/shared/page_title';
import { Box, Button, Stack } from '@mui/material';
import DataConfirmation from 'components/shared/data_confirmation';
import { FormButton, FormButtonType } from 'components/shared/form_button';
import { SnackbarFeedback } from 'components/shared/snackbar_feedback';
import { Modal } from 'components/shared/modal';
import { useConfirmData } from './useConfirmData';

const ConfirmSchoolFeeding: React.FC = () => {
  const { navigate, handleSubmit, loading, sucessModal, errorMessage } =
    useConfirmSchoolFeeding();
  const data = useConfirmData();

  return (
  <ContainerPainel
    showBackButton={true}
    pagina='CIFA - Cadastrar Município - 2025'
    backButtonPath={ROUTES.CREATE_MUNICIPAL_SCHOOL_FEEDING_2025}
  >
    <HorizontalStepper activeStep={5} />
    <PageTitle
      title='Confirmação de Dados'
      subtitle='Confirme todas as informações que foram preenchidas, e altere-as caso necessário.'
    />
    <Stack marginX='4rem'>
      <DataConfirmation
        title='Alimentação Escolar (Prefeitura)'
        data={[
          {
            label: 'Valor disponibilizado pelo Prefeitura:',
            value: `R$ ${Number(data.municipalProvided).toLocaleString('pt-BR')}`,
          },
          {
            label:
              'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
            value: `R$ ${Number(data.municipalApplied).toLocaleString('pt-BR')}`,
          },
        ]}
        dataProduct={[
          {
            title: 'Produtos adquiridos via CPF (com recurso do Prefeitura)',
            data: data.municipalCpfProducts.map((item: any) => ({
              name: item.name,
              cnpjOrcpf: item.identification,
              value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
            })),
          },
          {
            title: 'Produtos adquiridos via CNPJ (com recurso do Prefeitura)',
            data: data.municipalCnpjProducts.map((item: any) => ({
              name: item.name,
              cnpjOrcpf: item.identification,
              value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
            })),
          },
        ]}
      />

      <DataConfirmation
        title='Alimentação Escolar (Governo Estadual)'
        data={[
          {
            label: 'Valor disponibilizado pelo Governo Estadual:',
            value: `R$ ${Number(data.stateProvided).toLocaleString('pt-BR')}`,
          },
          {
            label:
              'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
            value: `R$ ${Number(data.stateApplied).toLocaleString('pt-BR')}`,
          },
        ]}
        dataProduct={[
          {
            title: 'Produtos adquiridos via CPF (com recurso do Governo Estadual)',
            data: data.stateCpfProducts.map((item: any) => ({
              name: item.name,
              cnpjOrcpf: item.identification,
              value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
            })),
          },
          {
            title: 'Produtos adquiridos via CNPJ (com recurso do Governo Estadual)',
            data: data.stateCnpjProducts.map((item: any) => ({
              name: item.name,
              cnpjOrcpf: item.identification,
              value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
            })),
          },
        ]}
      />

      <DataConfirmation
        title='Alimentação Escolar (PNAE Federal)'
        data={[
          {
            label: 'Valor disponibilizado pelo PNAE Federal:',
            value: `R$ ${Number(data.federalProvided).toLocaleString('pt-BR')}`,
          },
          {
            label:
              'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
            value: `R$ ${Number(data.federalApplied).toLocaleString('pt-BR')}`,
          },
        ]}
        dataProduct={[
          {
            title: 'Produtos adquiridos via CPF (com recurso do PNAE Federal) - Valores Aplicados na Aquisição de Produtos',
            data: data.federalCpfProducts.map((prod: any) => ({
              name: prod.name,
              cnpjOrcpf: prod.identification,
              value: `R$ ${Number(prod.value).toLocaleString('pt-BR')}`,
            })),
          },
          {
            title: 'Produtos adquiridos via CNPJ (com recurso do PNAE Federal) - Valores Aplicados na Aquisição de Produtos',
            data: data.federalCnpjProducts.map((prod: any) => ({
              name: prod.name,
              cnpjOrcpf: prod.identification,
              value: `R$ ${Number(prod.value).toLocaleString('pt-BR')}`,
            })),
          },
        ]}
      />

      <DataConfirmation
        title='Resumo'
        data={[
          {
            label:
              'Foi realizada parceria com instituição para execução da ATER?',
            value: data.aterServiceByMunicipalPartner ? 'Sim' : 'Não',
          },
          {
            label: 'Instituições parceiras:',
            value: data.aterMunicipalPartnerList
              .map((partner: any) => partner.name.toUpperCase())
              .join(', '),
          },
          {
            label:
              'Quantos beneficiários da Agricultura Familiar (unidade agro familiar) foram atendidos com ATER realizada exclusivamente pelo Município?',
            value: `${Number(data.aterExclusiveServiceMunicipality)}`,
          },
        ]}
      />

      <DataConfirmation
        title='Assistência Técnica e Extensão Rural'
        subData={data.aterMunicipalPartnerList.map((partner: any) => ({
          ata: [
            {
              label: 'Ata do CMDRS',
              fileName: partner.ataCmdrsDocument?.name,
              fileSize: '---',
              titlePDF: partner.ataCmdrsDocument?.name,
              onView: () =>
                partner.ataCmdrsDocument?.uuid &&
                window.open(`/files/${partner.ataCmdrsDocument.uuid}`),
            },
            {
              label: 'Documento de Formalização da Parceria',
              fileName: partner.partnershipDocument?.name,
              fileSize: '---',
              titlePDF: partner.partnershipDocument?.name,
              onView: () =>
                partner.partnershipDocument?.uuid &&
                window.open(`/files/${partner.partnershipDocument.uuid}`),
            },
          ],
          data: [
            {
              label:
                'Quantos beneficiários da Agricultura Familiar (unidade agro familiar) foram atendidos com ATER realizada pela instituição parceira no Município?',
              value: `${partner.numberOfBeneficiary}`,
            },
            {
              title: `${partner.name.toUpperCase()} - Dados da parceria com a Instituição (ATER)`,
            },
          ],
        }))}
      />
    </Stack>

    {/* Botões */}
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      gap={2}
      marginTop='20px'
    >
      <Button
        variant='text'
        sx={{
          color: '#1976D2',
          fontWeight: 'bold',
          textTransform: 'uppercase',
        }}
        onClick={() => navigate(ROUTES.CIFA2025)}
      >
        Voltar
      </Button>
      <Button
        variant='contained'
        onClick={handleSubmit}
        disabled={loading}
        sx={{
          backgroundColor: '#0048B6',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          '&:hover': {
            backgroundColor: '#003399',
          },
        }}
      >
        Confirmar e salvar
      </Button>
    </Box>

    <Modal
      open={sucessModal}
      onClose={() => navigate(ROUTES.CIFA2025)}
      title='Sucesso ao cadastrar munícipio!'
      subTitle='O município foi cadastrado com o sucesso no CIFA 2025'
      buttons={[
        <FormButton
          key={1}
          type={FormButtonType.PRIMARY}
          title='Voltar para a tela inicial'
          onClick={() => navigate(ROUTES.CIFA2025)}
        />,
      ]}
    />

    {errorMessage && (
      <SnackbarFeedback isOpen type='error' message={errorMessage} />
    )}
  </ContainerPainel>
);

};

export default ConfirmSchoolFeeding;
